module.exports = __webpack_public_path__ + "static/media/lemur.c9de6a57.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/primary-interface/lemur.svg
// module id = 622
// module chunks = 6